module.exports = __webpack_public_path__ + "img/teacher05.47eeb235.png";